var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "switch-set",
      staticStyle: { "min-height": "500px" }
    },
    [
      _vm.menuChnlEnabled
        ? _c(
            "div",
            [
              _vm.sysMenuChnls != null && _vm.sysMenuChnls.length > 0
                ? _c(
                    "el-tabs",
                    {
                      on: { "tab-click": _vm.handleClick },
                      model: {
                        value: _vm.activeName,
                        callback: function($$v) {
                          _vm.activeName = $$v
                        },
                        expression: "activeName"
                      }
                    },
                    _vm._l(_vm.sysMenuChnls, function(item) {
                      return _c(
                        "el-tab-pane",
                        { attrs: { label: item.name, name: item.name } },
                        _vm._l(item.sysMenus, function(sysMenu) {
                          return item.sysMenus != null
                            ? _c("div", [
                                _c(
                                  "div",
                                  {
                                    staticClass: "content-caption dashed",
                                    staticStyle: { margin: "5px 0" }
                                  },
                                  [
                                    _c("span", [
                                      _c("span", {
                                        staticClass: "color-laber"
                                      }),
                                      _vm._v(_vm._s(sysMenu.name))
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "el-checkbox",
                                      {
                                        attrs: {
                                          disabled: _vm.readOnly,
                                          indeterminate:
                                            _vm.stateMap[sysMenu.id]
                                              .indeterminate
                                        },
                                        on: {
                                          change: function(event) {
                                            _vm.handleCheckAllChange(
                                              event,
                                              sysMenu.id
                                            )
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.stateMap[sysMenu.id].checked,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.stateMap[sysMenu.id],
                                              "checked",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "stateMap[sysMenu.id].checked"
                                        }
                                      },
                                      [_c("span", [_vm._v("全选")])]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "ul",
                                  { staticClass: "switch-list clearfix ml10" },
                                  [
                                    _c(
                                      "el-checkbox-group",
                                      {
                                        on: {
                                          change: function(event) {
                                            _vm.handleCheckedResourcesChange(
                                              event,
                                              sysMenu.id
                                            )
                                          }
                                        },
                                        model: {
                                          value: _vm.rescIds,
                                          callback: function($$v) {
                                            _vm.rescIds = $$v
                                          },
                                          expression: "rescIds"
                                        }
                                      },
                                      _vm._l(sysMenu.sysMenuSons, function(
                                        sysMenuSon
                                      ) {
                                        return _c(
                                          "li",
                                          {
                                            staticClass:
                                              "switch-item ellipsis-1",
                                            staticStyle: {
                                              width: "auto",
                                              "margin-right": "30px"
                                            }
                                          },
                                          [
                                            sysMenuSon.sysResc != null
                                              ? _c(
                                                  "el-checkbox",
                                                  {
                                                    attrs: {
                                                      disabled: _vm.readOnly,
                                                      label:
                                                        sysMenuSon.sysResc.id
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        class: {
                                                          "font-italic font-gray2 mr5":
                                                            sysMenuSon.sysResc
                                                              .hiddenMenuFlag
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "icon iconfont icon-wujiaoxingman mr5",
                                                          staticStyle: {
                                                            color: "#eaea0f"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              sysMenuSon.name
                                                            )
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            sysMenuSon.sysResc != null &&
                                            sysMenuSon.sysResc.forBizUnionOnly
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "biz-union-indent"
                                                  },
                                                  [_vm._v("联盟专用")]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      })
                                    )
                                  ],
                                  1
                                )
                              ])
                            : _vm._e()
                        })
                      )
                    })
                  )
                : _vm._e()
            ],
            1
          )
        : _c(
            "div",
            _vm._l(_vm.sysMenuChnl.sysMenus, function(sysMenu) {
              return _vm.sysMenuChnl.sysMenus != null
                ? _c("div", [
                    _c(
                      "div",
                      {
                        staticClass: "content-caption dashed",
                        staticStyle: { margin: "5px 0" }
                      },
                      [
                        _c("span", [
                          _c("span", { staticClass: "color-laber" }),
                          _vm._v(_vm._s(sysMenu.name))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "switch-list clearfix ml10" },
                      [
                        _c(
                          "el-checkbox-group",
                          {
                            model: {
                              value: _vm.rescIds,
                              callback: function($$v) {
                                _vm.rescIds = $$v
                              },
                              expression: "rescIds"
                            }
                          },
                          _vm._l(sysMenu.sysMenuSons, function(sysMenuSon) {
                            return _c(
                              "li",
                              {
                                staticClass: "switch-item ellipsis-1",
                                staticStyle: {
                                  width: "auto",
                                  "margin-right": "30px"
                                }
                              },
                              [
                                sysMenuSon.sysResc != null
                                  ? _c(
                                      "el-checkbox",
                                      {
                                        attrs: { label: sysMenuSon.sysResc.id }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            class: {
                                              "font-italic font-gray2 mr5":
                                                sysMenuSon.sysResc
                                                  .hiddenMenuFlag
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "icon iconfont icon-wujiaoxingman mr5",
                                              staticStyle: { color: "#eaea0f" }
                                            }),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(_vm._s(sysMenuSon.name))
                                            ])
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                sysMenuSon.sysResc != null &&
                                sysMenuSon.sysResc.forBizUnionOnly
                                  ? _c(
                                      "span",
                                      { staticClass: "biz-union-indent" },
                                      [_vm._v("联盟专用")]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          })
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e()
            })
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ac5da74", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ac5da74","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/authx/MerchtTplRoleRescList.vue
// module id = 3465
// module chunks = 0